var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "current-game" }, [
    _vm.displayData
      ? _c("div", { staticClass: "current-game__container" }, [
          _c("div", { staticClass: "current-game__user-box" }, [
            _vm.displayData.user
              ? _c("img", {
                  staticClass: "current-game__avatar",
                  attrs: { src: _vm.avatarUrl, alt: "User Avatar" },
                })
              : _c("div", { staticClass: "current-game__avatar-placeholder" }),
            _c("div", { staticClass: "current-game__coefficient-badge" }, [
              _c("span", [_vm._v("x" + _vm._s(_vm.displayData.coefficient))]),
            ]),
          ]),
          _vm.displayData.winItem
            ? _c("img", {
                staticClass: "current-game__item-img",
                attrs: { src: _vm.winItemImgSrc, alt: "Win Item" },
              })
            : _vm._e(),
          _c("img", {
            staticClass: "current-game__item-light",
            attrs: {
              src: require("./assets/itemLight.webp"),
              alt: "Item Light",
            },
          }),
          _c("div", { staticClass: "current-game__info-box" }, [
            _c("div", { staticClass: "current-game__win-amount" }, [
              _c("i", {
                staticClass: "icon icon_coin-c current-game__coin-icon",
              }),
              _c("span", [_vm._v(_vm._s(_vm.displayData.winAmount))]),
            ]),
            _c("div", { staticClass: "current-game__platforms" }, [
              _c("span", { staticClass: "current-game__platforms-label" }, [
                _vm._v("步数:"),
              ]),
              _c("span", { staticClass: "current-game__platforms-value" }, [
                _vm._v(_vm._s(_vm.displayData.platformsCount)),
              ]),
            ]),
          ]),
          !_vm.$screen.mobile
            ? _c("img", {
                staticClass: "current-game__bg",
                attrs: { src: require("./assets/bg.webp"), alt: "Background" },
              })
            : _c("img", {
                staticClass: "current-game__bg",
                attrs: {
                  src: require("./assets/bgMob.webp"),
                  alt: "Background Mobile",
                },
              }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }